import moment from 'moment';

const checkOnDemandQueue = async () => {
        fetch(window.API_Path + 'calculatedValues/onDemandAvailability')
        .then((response) => response.json())
        .then((data) => {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                'onDemandAppointmentAvailable': (data.response.onDemandAppointmentAvailable ? 'on demand available' : 'on demand not available'),
                'onDemandAppointmentQueueSize': data.response.onDemandAppointmentQueueSize,
                'nextAppointmentAvailability': data.response.nextAppointmentAvailability
            });

            if(hotJarID()){
                dataLayer.push({
                    'event': 'HotJar',
                });
            }

        }).catch((error) => {
        console.log(error)
    })
}

const user = (localStorage.getItem('dod_user') ? JSON.parse(localStorage.getItem('dod_user')) : []);


const updateUserData = async() => {
        if(user.length){
            let _headers = new Headers();
            _headers.append("Authorization", "Bearer " + user[0].accessToken);

            let _requestOptions = {
                method: 'GET',
                headers: _headers,
                redirect: 'follow'
            };

            fetch(window.API_Path + 'patient/accountHolder', _requestOptions)
                .then((response) => response.json())
                .then(async (resData) => {

                    let userResult = await fetch(window.API_Path + 'patient/'+ resData.response.patiendId, _requestOptions)
                        .then((res) => res.json())
                        .then((response) => {
                            return response.response;
                        }).catch(err=>console.log(err));

                    let generalMedical = await  fetch(window.API_Path + 'patient/'+ resData.response.patiendId + '/generalMedical', _requestOptions)
                        .then((res) => res.json())
                        .then((response) => {
                            return response.response;
                        }).catch(err=>console.log(err));

                    let multiAccountRelationship = await fetch(window.API_Path + 'patients/'+ user[0].email, _requestOptions)
                        .then((res) => res.json())
                        .then((response) => {
                            let patientList = response.response.patients;
                            let multiAccountRelationship;

                            if (Array.isArray(patientList) && patientList.length) {
                                if (patientList.length === 1) {
                                    multiAccountRelationship = 'single account';
                                } else if (patientList.length > 1) {
                                    const patientDetail = patientList.find((p) => p.patientId === patient.patientId);
                                    if (patientDetail?.relationship) {
                                        multiAccountRelationship = 'multi account - ' + patientDetail.relationship;
                                    }
                                }
                            } else {
                                multiAccountRelationship = null;
                            }
                            return multiAccountRelationship;
                        }).catch(err=>console.log(err));

                    user[1] = {
                        ...generalMedical,
                        ...userResult,
                        'multiAccountRelationship' : multiAccountRelationship
                    };

                    localStorage.setItem('dod_user', JSON.stringify(user));
                    const event = new Event('dod_analytics_update');
                    document.dispatchEvent(event);

                }).catch((error) => {
                console.log(error)
            })
        }
}

document.addEventListener('dod_user_login', async () => {
    updateUserData();
})

document.addEventListener('dod_analytics_update', () => {
    let user = (localStorage.getItem('dod_user') ? JSON.parse(localStorage.getItem('dod_user')) : []);
    window.dataLayer = window.dataLayer || [];

        let curURL = window.location.href;
        let whiteLabel = document.querySelector('.single-whitelabel_site');
        // don't set dataLayer if in quit smoking or on whitelabel template
        if(curURL.includes('quit-smoking') || whiteLabel){
            return;
        }
    if(user.length) {
        if(!user[1]){
            updateUserData();
            return;
        }
        let userInfo = user[1];
        let age = Math.abs(moment().diff(moment(userInfo.dateOfBirth), 'years'));
        let gender = (userInfo.sex === 'M' ? 'Male' : 'Female');

        const heightCentimeters = parseInt(userInfo.height.replace('cm', ''));
        const heightMeters = heightCentimeters / 100;
        const weightKg = parseInt(userInfo.weight.replace('kg', ''));
        const bmi = weightKg / (heightMeters * heightMeters);

        let userBMI;
        if (bmi < 18.5) {
            userBMI = 'underweight';
        } else if (bmi >= 18.5 && bmi < 25) {
            userBMI = 'healthy weight';
        } else if (bmi >= 25 && bmi < 30) {
            userBMI = 'overweight';
        } else if (bmi >= 30) {
            userBMI = 'obese';
        }

        const bloodPressureArr = userInfo.bloodPressureValue
            ? userInfo.bloodPressureValue.split('/')
            : [null, null];
        const bloodPressureMm = isNaN(parseInt(bloodPressureArr[0])) ? null : parseInt(bloodPressureArr[0]);
        const bloodPressureHg = isNaN(parseInt(bloodPressureArr[1])) ? null : parseInt(bloodPressureArr[1]);
        let userBloodPressureRange;
        if (bloodPressureMm < 90 || bloodPressureHg < 60) {
            userBloodPressureRange = 'low';
        } else if (bloodPressureMm < 120 && bloodPressureHg < 80) {
            userBloodPressureRange = 'normal';
        } else if (bloodPressureMm >= 120 && bloodPressureMm < 130 && bloodPressureHg < 80) {
            userBloodPressureRange = 'elevated';
        } else if (bloodPressureMm >= 130 || bloodPressureHg > 90) {
            userBloodPressureRange = 'hypertension';
        } else {
            // Blood pressure values are invalid or fall outside of the normal ranges
            userBloodPressureRange = null;
        }

        // Medical Cards
        let medicalCards = [];
        if (userInfo.medicareCard?.cardNumber && userInfo.medicareCard?.medicareIRN && userInfo.medicareCard?.cardExpiry) {
            medicalCards.push('Medicare card');
        }
        if (userInfo.healthCareCard?.cardNumber && userInfo.healthCareCard?.cardExpiry) {
            medicalCards.push('Healthcare card');
        }
        if (userInfo.pensionCard?.cardNumber && userInfo.pensionCard?.cardExpiry) {
            medicalCards.push('Concession card');
        }
        if (userInfo.safetyNetCardNumber) {
            medicalCards.push('SafetyNet card');
        }
        if (userInfo.ihiNumber) {
            medicalCards.push('IHI number');
        }
        let userMedicalCards = medicalCards.length ? medicalCards.join(', ') : 'none';

            let userSmoker;
        if (userInfo.smoking === true) {
            userSmoker = 'smoker';
        } else if (userInfo.smoking === false) {
            userSmoker = 'non smoker';
        } else {
            // medical history has not been filled in
            userSmoker = null;
        }

        // DRINKING (ALCOHOL)
        // heavy drinker: For men, consuming [more than 4 drinks on any day] or more than 14 drinks per week,
        // For women, consuming [more than 3 drinks on any day] or more than 7 drinks per week
        let userDrinker;
        if (userInfo.alcohol === 'Not at all') {
            userDrinker = 'non drinker';
        } else if (userInfo.alcohol === 'More than 4 standard drinks per day') {
            userDrinker = 'heavy drinker';
        } else if (userInfo.alcohol) {
            userDrinker = 'drinker';
        } else {
            // medical history has not been filled in
            userDrinker = null
        }
        let userHasAllergies;
        if (userInfo.allergies === true) {
            userHasAllergies = 'allergies';
        } else if (userInfo.allergies === false) {
            userHasAllergies = 'no allergies';
        } else {
            // medical history has not been filled in
            userHasAllergies = null;
        }

        // HEART PROBLEMS
        let userHasHeartProblems;
        if (userInfo.heartProblems === true) {
            userHasHeartProblems = 'heart problems';
        } else if (userInfo.heartProblems === false) {
            userHasHeartProblems = 'no heart problems';
        } else {
            // medical history has not been filled in
            userHasHeartProblems = null;
        }

        // MEDICATION
        let userTakesMedication;
        if (userInfo.otherMedication === true/* && medicalHistory.otherMedicationMore*/) {
            userTakesMedication = 'takes medication';
        } else if (userInfo.otherMedication === false) {
            userTakesMedication = 'does not take medication';
        } else {
            // medical history has not been filled in
            userTakesMedication = null;
        }

        dataLayer.push({
            'userId': userInfo.patientId,
            'userType': 'marketing web - logged in',
            'userAgeAndGender': age + ' - ' + gender,
            'userLocation': userInfo.postCode,
            'multiAccountRelationship': userInfo.multiAccountRelationship,
            'userTakesMedication': userTakesMedication,
            'userBMI': userBMI,
            'userSmoker': userSmoker,
            'userDrinker': userDrinker,
            'userHasHeartProblems': userHasHeartProblems,
            'userHasAllergies': userHasAllergies,
            'userBloodPressureRange': userBloodPressureRange,
            'userMedicalCards': userMedicalCards,
            'userRegisteredThisSession': (userInfo.patientId ? 'existing patient' : null),
            'HotjarId': hotJarID(),
            'userCustomerType': 'b2c',
            'allowAdwords': ''
        });
    }else{
        dataLayer.push({
            'userType': 'marketing web - not logged in',
            'HotjarId': hotJarID(),
        });

    }

    const event = new Event('dod_datalayerReady');
    document.dispatchEvent(event);
})

window.addEventListener('DOMContentLoaded', () => {
    let curURL = window.location.href;
    let whiteLabel = document.querySelector('.single-whitelabel_site');
    // don't set dataLayer if in quit smoking or on whitelabel template
    if(curURL.includes('quit-smoking') || whiteLabel){
        return;
    }
    checkOnDemandQueue();

})

window.addEventListener('DOMContentLoaded', () => {
    const event = new Event('dod_analytics_update');
    document.dispatchEvent(event);
})


const hotJarID = () => {
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if(c.includes('_hjSessionUser_')){
            let splitString = c.split('=');
            let cookieKey = splitString[0];
            let hj = c.replace(cookieKey += '=', '');
            let hotjar = JSON.parse(atob(hj));
            let userId = hotjar['id'].split('-').shift();
            return (userId ?? false);
        }
    }
    return null;
}